<app-modal-shell
  data-cy="geschwister-adjust-modal"
  [title]="'TICKETS.GESCHWISTER.MODAL_TITLE'"
  [cancelLabel]="'TICKETS.GESCHWISTER.CANCEL_BUTTON'"
  [saveLabel]="'TICKETS.GESCHWISTER.SAVE_BUTTON'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <app-geschwister-details-form [ticketId]="ticketId"></app-geschwister-details-form>

</app-modal-shell>
